import React, { useState } from "react";

// import Checkbox from '@material-ui/Checkbox';

import { Card, Box } from "@material-ui/core";

// styles
import useStyles from "./styles";
// components

import { makeStyles as makeMuiStyles } from '@material-ui/core/styles';

const useManualStyles = makeMuiStyles((theme) => ({
    page: {
        padding: theme.spacing(2.5),
        background: "#f8fafc",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1.25),
        },
    },
    card: {
        maxWidth: 1100,
        margin: "0 auto",
        borderRadius: 24,
        overflow: "hidden",
        border: "1px solid #e2e8f0",
        boxShadow: "0 18px 40px rgba(15, 23, 42, 0.08)",
    },
    contentWrap: {
        margin: "0 auto",
        padding: theme.spacing(4),
        fontFamily: "Segoe UI, Arial, sans-serif",
        lineHeight: 1.8,
        color: "#334155",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
        "& h2": {
            color: "#0f3b62",
            fontSize: "2rem",
            fontWeight: 800,
            margin: theme.spacing(0, 0, 3),
            [theme.breakpoints.down("sm")]: {
                fontSize: "1.55rem",
                lineHeight: 1.3,
            },
        },
        "& h3": {
            color: "#0f3b62",
            fontSize: "1.35rem",
            fontWeight: 700,
            margin: theme.spacing(3.5, 0, 1.5),
            [theme.breakpoints.down("sm")]: {
                fontSize: "1.15rem",
            },
        },
        "& h4": {
            color: "#1e293b",
            fontSize: "1.05rem",
            fontWeight: 700,
            margin: theme.spacing(2.5, 0, 1.25),
        },
        "& h5": {
            color: "#475569",
            fontSize: "0.98rem",
            fontWeight: 700,
            margin: theme.spacing(2, 0, 1),
        },
        "& p": {
            fontSize: "0.98rem",
            lineHeight: 1.9,
            margin: theme.spacing(1.25, 0),
        },
        "& ul, & ol": {
            paddingLeft: theme.spacing(3),
            margin: theme.spacing(1.25, 0, 1.75),
        },
        "& li": {
            marginBottom: theme.spacing(0.9),
            lineHeight: 1.8,
        },
        "& a": {
            color: "#2563eb",
            fontWeight: 600,
        },
        "& table": {
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: 0,
            overflow: "hidden",
            borderRadius: 14,
            border: "1px solid #dbe3ee",
            marginTop: theme.spacing(2),
            background: "#ffffff",
            display: "block",
            overflowX: "auto",
        },
        "& thead": {
            background: "#eff6ff",
        },
        "& th": {
            color: "#1e3a8a",
            fontWeight: 700,
            whiteSpace: "nowrap",
        },
        "& th, & td": {
            padding: theme.spacing(1.5),
            borderBottom: "1px solid #e5e7eb",
            textAlign: "left",
            fontSize: "0.95rem",
        },
        "& tr:last-child td": {
            borderBottom: "none",
        },
    },
}));
export default function UserManual(props) {
    const classes = useStyles();
    const manualClasses = useManualStyles();
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);

    return (

        <Box className={manualClasses.page}>
            <Card className={manualClasses.card}>
                <Box>
                    <div className={manualClasses.contentWrap}>


                    <div style={{  }}>
      <h2>➢ Montestory School Registration - User Manual</h2>

      <div style={{ 
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "2.5rem", 
        borderRadius: "20px", 
        marginBottom: "3rem",
        boxShadow: "0 20px 40px rgba(102, 126, 234, 0.3)",
        position: "relative",
        overflow: "hidden"
      }}>
        <div style={{
          position: "absolute",
          top: "-50%",
          right: "-20%",
          width: "200px",
          height: "200px",
          background: "rgba(255, 255, 255, 0.1)",
          borderRadius: "50%",
          zIndex: 0
        }}></div>
        <div style={{
          position: "absolute",
          bottom: "-30%",
          left: "-10%",
          width: "150px",
          height: "150px",
          background: "rgba(255, 255, 255, 0.05)",
          borderRadius: "50%",
          zIndex: 0
        }}></div>
        
        <div style={{ position: "relative", zIndex: 1 }}>
          <h3 style={{ 
            marginTop: "0", 
            color: "white", 
            fontSize: "2rem",
            fontWeight: "700",
            textAlign: "center",
            marginBottom: "0.5rem",
            textShadow: "0 2px 4px rgba(0,0,0,0.3)"
          }}>📋 Quick Navigation</h3>
          <p style={{
            color: "rgba(255, 255, 255, 0.9)",
            textAlign: "center",
            fontSize: "1.1rem",
            marginBottom: "2rem",
            fontWeight: "300"
          }}>Jump to any section instantly</p>
          
          <div style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", 
            gap: "1.5rem",
            maxWidth: "1200px",
            margin: "0 auto"
          }}>
            <div onClick={() => document.getElementById('introduction')?.scrollIntoView({ behavior: 'smooth' })} style={{ 
              background: "rgba(255, 255, 255, 0.95)",
              padding: "1.5rem", 
              borderRadius: "16px",
              cursor: "pointer",
              transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(10px)",
              position: "relative",
              overflow: "hidden"
            }} onMouseOver={(e) => {
              e.target.style.transform = "translateY(-8px) scale(1.02)";
              e.target.style.boxShadow = "0 20px 40px rgba(0,0,0,0.15)";
              e.target.style.background = "rgba(255, 255, 255, 1)";
            }} onMouseOut={(e) => {
              e.target.style.transform = "translateY(0) scale(1)";
              e.target.style.boxShadow = "none";
              e.target.style.background = "rgba(255, 255, 255, 0.95)";
            }}>
              <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
                <div style={{ 
                  width: "40px", 
                  height: "40px", 
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "1rem",
                  fontSize: "1.2rem"
                }}>📖</div>
                <h4 style={{ margin: 0, color: "#2d3748", fontSize: "1.1rem", fontWeight: "600" }}>Introduction</h4>
              </div>
              <p style={{ margin: 0, color: "#718096", fontSize: "0.9rem", lineHeight: "1.4" }}>Welcome to Montestory platform overview</p>
            </div>

            <div onClick={() => document.getElementById('school-registration')?.scrollIntoView({ behavior: 'smooth' })} style={{ 
              background: "rgba(255, 255, 255, 0.95)",
              padding: "1.5rem", 
              borderRadius: "16px",
              cursor: "pointer",
              transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(10px)"
            }} onMouseOver={(e) => {
              e.target.style.transform = "translateY(-8px) scale(1.02)";
              e.target.style.boxShadow = "0 20px 40px rgba(0,0,0,0.15)";
              e.target.style.background = "rgba(255, 255, 255, 1)";
            }} onMouseOut={(e) => {
              e.target.style.transform = "translateY(0) scale(1)";
              e.target.style.boxShadow = "none";
              e.target.style.background = "rgba(255, 255, 255, 0.95)";
            }}>
              <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
                <div style={{ 
                  width: "40px", 
                  height: "40px", 
                  background: "linear-gradient(135deg, #48bb78 0%, #38a169 100%)",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "1rem",
                  fontSize: "1.2rem"
                }}>🏫</div>
                <h4 style={{ margin: 0, color: "#2d3748", fontSize: "1.1rem", fontWeight: "600" }}>School Registration</h4>
              </div>
              <p style={{ margin: 0, color: "#718096", fontSize: "0.9rem", lineHeight: "1.4" }}>Complete step-by-step registration guide</p>
            </div>

            <div onClick={() => document.getElementById('student-registration')?.scrollIntoView({ behavior: 'smooth' })} style={{ 
              background: "rgba(255, 255, 255, 0.95)",
              padding: "1.5rem", 
              borderRadius: "16px",
              cursor: "pointer",
              transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(10px)"
            }} onMouseOver={(e) => {
              e.target.style.transform = "translateY(-8px) scale(1.02)";
              e.target.style.boxShadow = "0 20px 40px rgba(0,0,0,0.15)";
              e.target.style.background = "rgba(255, 255, 255, 1)";
            }} onMouseOut={(e) => {
              e.target.style.transform = "translateY(0) scale(1)";
              e.target.style.boxShadow = "none";
              e.target.style.background = "rgba(255, 255, 255, 0.95)";
            }}>
              <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
                <div style={{ 
                  width: "40px", 
                  height: "40px", 
                  background: "linear-gradient(135deg, #9f7aea 0%, #805ad5 100%)",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "1rem",
                  fontSize: "1.2rem"
                }}>👨‍🎓</div>
                <h4 style={{ margin: 0, color: "#2d3748", fontSize: "1.1rem", fontWeight: "600" }}>Student Registration</h4>
              </div>
              <p style={{ margin: 0, color: "#718096", fontSize: "0.9rem", lineHeight: "1.4" }}>Excel upload and manual registration</p>
            </div>

            <div onClick={() => document.getElementById('teacher-registration')?.scrollIntoView({ behavior: 'smooth' })} style={{ 
              background: "rgba(255, 255, 255, 0.95)",
              padding: "1.5rem", 
              borderRadius: "16px",
              cursor: "pointer",
              transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(10px)"
            }} onMouseOver={(e) => {
              e.target.style.transform = "translateY(-8px) scale(1.02)";
              e.target.style.boxShadow = "0 20px 40px rgba(0,0,0,0.15)";
              e.target.style.background = "rgba(255, 255, 255, 1)";
            }} onMouseOut={(e) => {
              e.target.style.transform = "translateY(0) scale(1)";
              e.target.style.boxShadow = "none";
              e.target.style.background = "rgba(255, 255, 255, 0.95)";
            }}>
              <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
                <div style={{ 
                  width: "40px", 
                  height: "40px", 
                  background: "linear-gradient(135deg, #4299e1 0%, #3182ce 100%)",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "1rem",
                  fontSize: "1.2rem"
                }}>👨‍🏫</div>
                <h4 style={{ margin: 0, color: "#2d3748", fontSize: "1.1rem", fontWeight: "600" }}>Teacher Registration</h4>
              </div>
              <p style={{ margin: 0, color: "#718096", fontSize: "0.9rem", lineHeight: "1.4" }}>Add and manage teacher accounts</p>
            </div>

            <div onClick={() => document.getElementById('teacher-login')?.scrollIntoView({ behavior: 'smooth' })} style={{ 
              background: "rgba(255, 255, 255, 0.95)",
              padding: "1.5rem", 
              borderRadius: "16px",
              cursor: "pointer",
              transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(10px)"
            }} onMouseOver={(e) => {
              e.target.style.transform = "translateY(-8px) scale(1.02)";
              e.target.style.boxShadow = "0 20px 40px rgba(0,0,0,0.15)";
              e.target.style.background = "rgba(255, 255, 255, 1)";
            }} onMouseOut={(e) => {
              e.target.style.transform = "translateY(0) scale(1)";
              e.target.style.boxShadow = "none";
              e.target.style.background = "rgba(255, 255, 255, 0.95)";
            }}>
              <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
                <div style={{ 
                  width: "40px", 
                  height: "40px", 
                  background: "linear-gradient(135deg, #ed8936 0%, #dd6b20 100%)",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "1rem",
                  fontSize: "1.2rem"
                }}>🔑</div>
                <h4 style={{ margin: 0, color: "#2d3748", fontSize: "1.1rem", fontWeight: "600" }}>Teacher Login</h4>
              </div>
              <p style={{ margin: 0, color: "#718096", fontSize: "0.9rem", lineHeight: "1.4" }}>Login process and credentials</p>
            </div>

            <div onClick={() => document.getElementById('teacher-features')?.scrollIntoView({ behavior: 'smooth' })} style={{ 
              background: "rgba(255, 255, 255, 0.95)",
              padding: "1.5rem", 
              borderRadius: "16px",
              cursor: "pointer",
              transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(10px)"
            }} onMouseOver={(e) => {
              e.target.style.transform = "translateY(-8px) scale(1.02)";
              e.target.style.boxShadow = "0 20px 40px rgba(0,0,0,0.15)";
              e.target.style.background = "rgba(255, 255, 255, 1)";
            }} onMouseOut={(e) => {
              e.target.style.transform = "translateY(0) scale(1)";
              e.target.style.boxShadow = "none";
              e.target.style.background = "rgba(255, 255, 255, 0.95)";
            }}>
              <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
                <div style={{ 
                  width: "40px", 
                  height: "40px", 
                  background: "linear-gradient(135deg, #38a169 0%, #2f855a 100%)",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "1rem",
                  fontSize: "1.2rem"
                }}>⚡</div>
                <h4 style={{ margin: 0, color: "#2d3748", fontSize: "1.1rem", fontWeight: "600" }}>Teacher Features</h4>
              </div>
              <p style={{ margin: 0, color: "#718096", fontSize: "0.9rem", lineHeight: "1.4" }}>Available tools and capabilities</p>
            </div>

            <div onClick={() => document.getElementById('parent-login')?.scrollIntoView({ behavior: 'smooth' })} style={{ 
              background: "rgba(255, 255, 255, 0.95)",
              padding: "1.5rem", 
              borderRadius: "16px",
              cursor: "pointer",
              transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(10px)"
            }} onMouseOver={(e) => {
              e.target.style.transform = "translateY(-8px) scale(1.02)";
              e.target.style.boxShadow = "0 20px 40px rgba(0,0,0,0.15)";
              e.target.style.background = "rgba(255, 255, 255, 1)";
            }} onMouseOut={(e) => {
              e.target.style.transform = "translateY(0) scale(1)";
              e.target.style.boxShadow = "none";
              e.target.style.background = "rgba(255, 255, 255, 0.95)";
            }}>
              <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
                <div style={{ 
                  width: "40px", 
                  height: "40px", 
                  background: "linear-gradient(135deg, #e53e3e 0%, #c53030 100%)",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "1rem",
                  fontSize: "1.2rem"
                }}>👨‍👩‍👧‍👦</div>
                <h4 style={{ margin: 0, color: "#2d3748", fontSize: "1.1rem", fontWeight: "600" }}>Parent Login</h4>
              </div>
              <p style={{ margin: 0, color: "#718096", fontSize: "0.9rem", lineHeight: "1.4" }}>Parent portal access and features</p>
            </div>

            <div onClick={() => document.getElementById('dashboard-features')?.scrollIntoView({ behavior: 'smooth' })} style={{ 
              background: "rgba(255, 255, 255, 0.95)",
              padding: "1.5rem", 
              borderRadius: "16px",
              cursor: "pointer",
              transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              backdropFilter: "blur(10px)"
            }} onMouseOver={(e) => {
              e.target.style.transform = "translateY(-8px) scale(1.02)";
              e.target.style.boxShadow = "0 20px 40px rgba(0,0,0,0.15)";
              e.target.style.background = "rgba(255, 255, 255, 1)";
            }} onMouseOut={(e) => {
              e.target.style.transform = "translateY(0) scale(1)";
              e.target.style.boxShadow = "none";
              e.target.style.background = "rgba(255, 255, 255, 0.95)";
            }}>
              <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
                <div style={{ 
                  width: "40px", 
                  height: "40px", 
                  background: "linear-gradient(135deg, #805ad5 0%, #6b46c1 100%)",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "1rem",
                  fontSize: "1.2rem"
                }}>📊</div>
                <h4 style={{ margin: 0, color: "#2d3748", fontSize: "1.1rem", fontWeight: "600" }}>Dashboard Features</h4>
              </div>
              <p style={{ margin: 0, color: "#718096", fontSize: "0.9rem", lineHeight: "1.4" }}>School management capabilities</p>
            </div>
          </div>
        </div>
      </div>

      <h3 id="introduction">Introduction</h3>
      <p>
        <strong>Welcome to Montestory!</strong><br />
        This guide will help schools register on the platform easily and correctly.
      </p>

      <h3 id="school-registration">Step-by-Step School Registration Guide</h3>

      <h4>1. Visit the Website</h4>
      <ul>
        <li>Open your browser.</li>
        <li>
          Go to <a href="https://www.montestory.in" target="_blank" rel="noopener noreferrer">https://www.montestory.in</a>.
        </li>
        <li>Click <strong>“School Registration”</strong> at the top right corner of the homepage.</li>
      </ul>

      <h4>2. Fill in the School Registration Form</h4>
      <ul>
        <li><strong>Name of the school:</strong> You need to enter name of your school</li>
      </ul>

      <h5>A. Address Details</h5>
      <ul>
        <li><strong>Address:</strong> Enter the complete address of the school.</li>
        <li><strong>City:</strong> Enter the city where the school is located.</li>
        <li><strong>Pin Code:</strong> Enter the correct postal/ZIP code.</li>
        <li><strong>Select Country:</strong> Choose your country from the dropdown menu.</li>
      </ul>

      <h5>B. Contact Details</h5>
      <ul>
        <li><strong>Full Name:</strong> Enter the name of the school’s authorized contact person.</li>
        <li><strong>Mobile Number:</strong> Enter the personal mobile number of the contact person.</li>
        <li><strong>School Contact Number:</strong> Enter the official phone number of the school.</li>
        <li><strong>Email ID:</strong> Enter the personal email address of the contact person.</li>
        <li><strong>School Email:</strong> Enter the official email address of the school.</li>
        <li><strong>Set Password:</strong> Create a strong password for your school account. (Remember to keep it safe.)</li>
      </ul>

      <h4>3. Avail Trial Subscription</h4>
      <ul>
        <li>Choose <strong>Yes</strong> if you want to try a free trial subscription.</li>
        <li>Choose <strong>No</strong> if you want to skip the trial.</li>
      </ul>

      <h4>4. Agree to Terms and Conditions</h4>
      <ul>
        <li>
          Read the <strong>Privacy Policy</strong> and <strong>Terms & Conditions</strong> by clicking the provided links.
        </li>
      </ul>
      <h4>5. Submit the Form</h4>
      <ul>
        <li>After filling all fields and accepting the terms and privacy policy, click the <strong>SUBMIT</strong> button at the bottom right.</li>
        <li>Your school account will be activated once admin verifies the details.</li>
      </ul>

      <h4>Important Notes</h4>
      <ul>
        <li>Make sure your email ID and mobile number are correct, as you will receive important notifications there.</li>
        <li>Passwords should be strong (at least 8 characters, with numbers, capital letters, and special characters).</li>
        <li>Always review your details before submitting.</li>
      </ul>

      <h4>After Registration</h4>
      <ul>
        <li>Once you’ve submitted the form, our team will verify your information and activate your account.</li>
        <li>Use your registered <strong>mobile number and password</strong> to log in.</li>
      </ul>

      <h3 id="student-registration">1. Student Registration</h3>

      <h4>Option 1: Upload Excel File</h4>
      <ul>
        <li>Navigate to <strong>Student Details</strong> on the left menu.</li>
        <li>You will see a button: <strong>Choose File ➔ UPLOAD EXCEL</strong></li>
        <li>Click <strong>Download Sample Format</strong> first to get the sample Excel file.</li>
        <li>Fill your student data in the sample Excel file correctly.</li>
        <li>After filling, <strong>Choose File</strong> and <strong>UPLOAD EXCEL</strong>.</li>
      </ul>

      <h4>Option 2: Manual Student Registration</h4>
      <ul>
        <li>Click the <strong>STUDENT REGISTRATION</strong> button (top right corner).</li>
        <li>Fill in the student details:</li>
        <ul style={{ listStyleType: "circle", marginLeft: "1.5rem" }}>
          <li>Admission Number</li>
          <li>First Name</li>
          <li>Last Name</li>
          <li>Date of Birth</li>
        </ul>
      </ul>
    </div>
    <h3 id="teacher-registration">2. Teacher Registration</h3>
      <ul>
        <li>Navigate to <strong>Teacher</strong> section on the left menu.</li>
        <li>Click the <strong>TEACHER REGISTRATION</strong> button.</li>
        <li>Fill in the teacher’s information:</li>
        <ul style={{ listStyleType: "circle", marginLeft: "1.5rem" }}>
          <li>First Name</li>
          <li>Last Name</li>
          <li>Mobile Number</li>
          <li>Email ID</li>
          <li>Date of Joining</li>
          <li>Class Assigned</li>
        </ul>
        <li>Set a password for the teacher’s login.</li>
        <li>Click <strong>Submit</strong>.</li>
        <li>The teacher will be added and can log in using the mobile number and password.</li>
      </ul>

      <h3 id="dashboard-features">3. What You Can Track Inside the School Dashboard</h3>
      <p>After logging in, the school can manage or monitor:</p>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "8px", background: "#f5f5f5" }}>Module</th>
            <th style={{ border: "1px solid #ccc", padding: "8px", background: "#f5f5f5" }}>What You Can Do</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Student Details</td>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>View, edit, delete students; search by name.</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Class</td>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Manage classes and assign students and teachers.</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Teacher</td>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Add new teachers; manage teacher list.</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Attendance</td>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>
              Mark daily attendance for students by selecting a single student or you can select all.
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Area of Work</td>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Assign subject areas and track learning outcomes.</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>List of Activities</td>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Manage and track class activities.</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Exercise</td>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Upload and track exercises and assignments.</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Student Activity</td>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Monitor student participation in activities.</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Weekly Planner 
            </td>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Create weekly lesson plans for each class and lesson. </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Special 
            Observation </td>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Record special notes/observations for students. 
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Charts </td>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Visual reports (graphs/charts) for student progress, attendance, etc. </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Reports </td>
            <td style={{ border: "1px solid #ccc", padding: "8px" }}>Download detailed reports for students, teachers, and activities.</td>
          </tr>
        </tbody>
        </table>
        <h4>4. Other Features</h4>
      <ul>
        <li>
          <strong>Edit/Delete Students:</strong> Click on the pencil 🖉 to edit or the bin 🗑️ to delete a student.
        </li>
        <li>
          <strong>Search Students:</strong> Use the search bar to quickly find students by name.
        </li>
        <li>
          <strong>Pagination:</strong> Adjust how many records you see per page (e.g., 10, 50, 1000).
        </li>
      </ul>

      <h3 id="teacher-login" style={{ marginTop: "2rem" }}>➢ Teacher Registration Process</h3>
      <p>
        Once the school admin registers the teacher, the teacher receives login credentials (Mobile Number & Password) to access their account.
      </p>

      <h4>New Dynamic Activity Planner Feature</h4>
      <ul>
        <li><strong>Enhanced Planning Tool:</strong> A new Dynamic Activity Planner feature has been added to the Teacher Module.</li>
        <li><strong>Flexible Date Selection:</strong> Teachers can now easily select a date range by choosing From Date and To Date to plan and organize classroom activities.</li>
        <li><strong>Fully Editable:</strong> The planner is fully editable — teachers can make changes at any time using the Edit button to update or modify planned activities as needed.</li>
        <li><strong>Efficient Management:</strong> This enhancement helps teachers manage daily, weekly, or monthly activities efficiently.</li>
      </ul>

      <h4>2. Teacher Login</h4>
      <p><strong>Step 1:</strong> Go to the Login page.</p>
      <p><strong>Step 2:</strong> Select the <strong>"Teacher"</strong> tab at the top (green button).</p>
      <p><strong>Step 3:</strong> Enter your:</p>
      <ul>
        <li>Registered Mobile Number</li>
        <li>Password</li>
      </ul>
      <p>Click <strong>Login</strong> to access the dashboard.</p>
      <p>If you forgot your password, click <strong>“Forgot Password?”</strong> to reset.</p>

      <h4 id="teacher-features">3. After Login - What Can a Teacher Do?</h4>
     
    
      <h4>After successful login, teachers can:</h4>

<ul>
  <li>
    <strong>Weekly Planner</strong>
    <ul style={{ listStyleType: "circle", marginLeft: "1.5rem" }}>
      <li>View, Plan, and Manage students’ weekly activities.</li>
      <li>Select Class & Student, set the start and end dates, and search activities.</li>
      <li>Add New Activities (using “Add Activity” button).</li>
      <li>Export Weekly Plan to Excel for reporting.</li>
    </ul>
  </li>

  <li>
    <strong>Activity Recorder</strong>
    <ul style={{ listStyleType: "circle", marginLeft: "1.5rem" }}>
      <li>Record daily or weekly student activities.</li>
      <li>Update learning outcomes achieved by students.</li>
    </ul>
  </li>

  <li>
    <strong>Student Details</strong>
    <ul style={{ listStyleType: "circle", marginLeft: "1.5rem" }}>
      <li>View list of students in assigned classes.</li>
      <li>Access basic details of each student.</li>
    </ul>
  </li>

  <li>
    <strong>Attendance</strong>
    <ul style={{ listStyleType: "circle", marginLeft: "1.5rem" }}>
      <li>Mark daily attendance for students.</li>
      <li>View attendance reports for any date range.</li>
    </ul>
  </li>

  <li>
    <strong>Lesson Plan</strong>
    <ul style={{ listStyleType: "circle", marginLeft: "1.5rem" }}>
      <li>Manage structured lesson plans.</li>
      <li>Assign activities or curriculum for future dates.</li>
    </ul>
  </li>

  <li>
    <strong>Charts</strong>
    <ul style={{ listStyleType: "circle", marginLeft: "1.5rem" }}>
      <li>Track student recognition and pronunciation of individual phonetic sounds.</li>
      <li>Support Montessori word-building using movable alphabets.</li>
    </ul>
  </li>

  <li>
    <strong>Reports</strong>
    <ul style={{ listStyleType: "circle", marginLeft: "1.5rem" }}>
      <li>
        Filter by class, student name, and date range to view detailed attendance
        (working days, present, absent).
      </li>
      <li>
        Track student progress in activities by filtering class, student, and date range.
      </li>
    </ul>
  </li>

  <li>
    <strong>Assignment</strong>
    <ul style={{ listStyleType: "circle", marginLeft: "1.5rem" }}>
      <li>Upload new assignments for students.</li>
      <li>Set due dates and track submissions.</li>
    </ul>
  </li>

  <li>
    <strong>Calendar Events</strong>
    <ul style={{ listStyleType: "circle", marginLeft: "1.5rem" }}>
      <li>View all important school events and holidays.</li>
      <li>Stay updated on upcoming activities.</li>
    </ul>
  </li>
</ul>   
<h4>4. Special Features</h4>
      <ul>
        <li>
          <strong>✅ Excel Export:</strong> Teachers can export weekly plans and reports to Excel files.
        </li>
        <li>
          <strong>✅ Role-Based Access:</strong> Teachers only see and manage data relevant to their assigned classes/students.
        </li>
      </ul>

      <h3 id="parent-login">➢ Montestory Parent Login</h3>

      <h4>Parent Login Process</h4>
      <ul>
        <li><strong>No Mobile Number Required:</strong> In the updated Parents Module, there is no need to add the parent's mobile number during registration.</li>
        <li><strong>Unique Student ID:</strong> Each student will be assigned a unique ID, which will serve as the username or login ID for accessing the parent portal.</li>
        <li><strong>Simplified Login:</strong> This simplifies the login process and ensures every student has a unique and secure identity within the system.</li>
        <li><strong>Secure Access:</strong> Parents can log in using their child's unique student ID and the password provided by the school.</li>
      </ul>

      <h4>After Login - Parent Dashboard</h4>
      <p>
        After successful login, you will see two main sections on the left panel:
      </p>
      <ul>
        <li><strong>Assignment</strong></li>
        <li><strong>Calendar</strong></li>
      </ul>

      <h4>Assignments Section</h4>
      <ul>
        <li>Click on <strong>Assignment</strong> from the left menu.</li>
        <li>You will see a list of assignments for your child.</li>
        <li>Information available:</li>
        <ul style={{ listStyleType: "circle", marginLeft: "1.5rem" }}>
          <li><strong>Assignment:</strong> Title of the assignment.</li>
          <li><strong>Assignment Date:</strong> Date when the assignment was given.</li>
          <li><strong>Due Date:</strong> Deadline for submitting the assignment.</li>
          <li><strong>Remarks:</strong> Any comments or instructions.</li>
          <li><strong>Status:</strong> Whether the assignment is Submitted or Not Submitted.</li>
          <li><strong>Request for Resubmission:</strong> (if applicable) whether resubmission is requested.</li>
        </ul>
      </ul>

        <h4>Calendar Section</h4>
        <ul>
          <li>Click on <strong>Calendar</strong> from the left menu.</li>
          <li>You can view important dates, assignment due dates, school events, and more.</li>
        </ul>

        <div style={{ 
          textAlign: "center", 
          marginTop: "4rem", 
          padding: "3rem 2rem",
          background: "linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)",
          borderRadius: "20px",
          border: "1px solid rgba(226, 232, 240, 0.8)",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.05)"
        }}>
          <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{ 
            color: "white", 
            textDecoration: "none", 
            padding: "1.2rem 3rem", 
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", 
            borderRadius: "50px",
            border: "none",
            fontSize: "1.1rem",
            fontWeight: "600",
            transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
            display: "inline-flex",
            alignItems: "center",
            gap: "0.5rem",
            cursor: "pointer",
            fontFamily: "inherit",
            boxShadow: "0 8px 20px rgba(102, 126, 234, 0.3)",
            position: "relative",
            overflow: "hidden"
          }} onMouseOver={(e) => {
            e.target.style.transform = "translateY(-4px) scale(1.05)";
            e.target.style.boxShadow = "0 15px 35px rgba(102, 126, 234, 0.4)";
            e.target.style.background = "linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%)";
          }} onMouseOut={(e) => {
            e.target.style.transform = "translateY(0) scale(1)";
            e.target.style.boxShadow = "0 8px 20px rgba(102, 126, 234, 0.3)";
            e.target.style.background = "linear-gradient(135deg, #667eea 0%, #764ba2 100%)";
          }}>
            <span style={{ fontSize: "1.2rem" }}>⬆️</span>
            <span>Back to Top</span>
          </button>
          <p style={{ 
            marginTop: "1rem", 
            color: "#718096", 
            fontSize: "0.9rem",
            fontWeight: "400"
          }}>Thank you for using Montestory User Manual</p>
        </div>
                            
                    </div>
                </Box>
            </Card>
        </Box>
    );
}


